import { getTileWarnings } from 'pages/PhotoStyler/TileWarning/tileWarning.utils'
import type { BaseTileStore } from 'stores/tilesStore/tiles/BaseTileStore'
import type { TileCartItemWarning } from '../../CartItem'
import { experimentManager } from 'services/ExperimentManager/ExperimentManager'

export function computeTilesWarnings(
  tiles: BaseTileStore[]
): TileCartItemWarning[] {
  const warnings: TileCartItemWarning[] = []
  for (const tile of tiles) {
    const tileWarnings = getTileWarnings(tile, experimentManager)
    for (const warning of tileWarnings) {
      warnings.push({ type: warning.type, tileId: tile.id })
    }
  }
  return warnings
}
